// extracted by mini-css-extract-plugin
module.exports = {"PrimaryColor":"#1d97c1","BreakpointSmall":"400px","HeaderHeight":"60px","text":"_1ofT3","active":"_2_7TO"};